import jwt_decode from 'jwt-decode'

export function decodeJwtPayload<T>(token: string): T | null {
  try {
    return jwt_decode<T>(token)
  } catch {
    return null
  }
}
